import { api } from 'restaurantAdmin/api';

export { getGuest } from 'restaurantAdmin/guestBook/apiHelpers';

export enum MessageSender {
  Restaurant = 'restaurant',
  Guest = 'guest',
}

export interface MessageUser {
  id: string;
  firstName: string;
  lastName: string;
}

export interface RestaurantAdminMessageSender {
  id: string;
  fullName: string;
}

export interface Message {
  id: string;
  message: string;
  createdAt: string;
  sender: MessageSender;
  user: MessageUser;
  readAt?: string | null;
  sentBy?: RestaurantAdminMessageSender;
}

export interface RestaurantMessageOptions {
  limit: number;
  unreadOnly: boolean;
  sender: MessageSender | MessageSender[];
}

export type OptionalRestaurantMessageOptions =
  Partial<RestaurantMessageOptions>;

export const getMessages = async (
  restaurantId: string,
  guestId: string,
): Promise<Message[]> =>
  api.get(`/restaurants/${restaurantId}/messaging/${guestId}/messages`);

export const getRestaurantMessages = (
  restaurantId: string,
  options: RestaurantMessageOptions,
) => {
  const params = new URLSearchParams();
  params.set('limit', String(options.limit));
  params.set('unreadOnly', String(options.unreadOnly));
  const senders = Array.isArray(options.sender)
    ? options.sender
    : [options.sender];
  for (const s of senders) {
    params.append('sender', s);
  }
  return api.get<Message[]>(
    `/restaurants/${restaurantId}/messages?${params.toString()}`,
  );
};

export const saveMessage = async (
  restaurantId: string,
  guestId: string,
  message: string,
): Promise<MessageSender> =>
  api.post(`/restaurants/${restaurantId}/messaging/${guestId}/message`, {
    message,
  });

export const markMessagesAsRead = async (
  restaurantId: string,
  guestId: string,
  messageIds: string[],
): Promise<void> =>
  api.post(`/restaurants/${restaurantId}/messaging/${guestId}/messages/read`, {
    messageIds,
  });

export const sendMassMessage = async (
  restaurantId: string,
  userIds: string[],
  message: string,
): Promise<void> =>
  api.post(`/restaurants/${restaurantId}/messaging/message`, {
    userIds,
    message,
  });
